export default {
  restore: '还原',
  'Are you sure to restore the selected records?': '确定还原选中记录？',
  'Restore the selected record to the original data table':
    '还原选中记录到原数据表',
  'Operation administrator': '操作管理员',
  'Recycling rule name': '回收规则名称',
  'Rule name': '规则名称',
  controller: '控制器',
  'data sheet': '数据表',
  DeletedData: '被删数据',
  'Arbitrary fragment fuzzy query': '任意片段模糊查询',
  'Click to expand': '点击展开',
  'Data table primary key': '数据表主键',
  'Operator IP': '操作者IP',
  'Deleted data': '被删除的数据',
  'Delete time': '删除时间'
}
